import React, { useState, useEffect } from 'react'

export default function ConfigFunnelDesign({ funnel, open, onClose, onSave, settingsFunnel, setSettingsFunnel }) {

    const [logoWidth, setLogoWidth] = useState(settingsFunnel?.logoWidth || 20);
    const [currentSettings, setCurrentSettings] = useState(settingsFunnel);
    
    const fontOptions = [
        { name: "Inter", value: "Inter, sans-serif" },
        { name: "Roboto", value: "Roboto, sans-serif" },
        { name: "Montserrat", value: "Montserrat, sans-serif" },
        { name: "Georgia", value: "Georgia, serif" },
        { name: "Arial", value: "Arial, sans-serif" },
        { name: "Helvetica", value: "Helvetica, Arial, sans-serif" },
        { name: "Times New Roman", value: "'Times New Roman', serif" },
        { name: "Courier New", value: "'Courier New', monospace" },
        { name: "Lato", value: "Lato, sans-serif" },
        { name: "Oswald", value: "Oswald, sans-serif" },
        { name: "Poppins", value: "Poppins, sans-serif" },
        { name: "Open Sans", value: "'Open Sans', sans-serif" },
        { name: "Raleway", value: "Raleway, sans-serif" },
        { name: "Merriweather", value: "Merriweather, serif" },
        { name: "Nunito", value: "Nunito, sans-serif" },
        { name: "Quicksand", value: "Quicksand, sans-serif" },
        { name: "Playfair Display", value: "'Playfair Display', serif" },
        { name: "Fira Sans", value: "'Fira Sans', sans-serif" },
        { name: "Rubik", value: "Rubik, sans-serif" },
        { name: "Bebas Neue", value: "'Bebas Neue', cursive" },
        { name: "DM Sans", value: "'DM Sans', sans-serif" },
        { name: "Work Sans", value: "'Work Sans', sans-serif" },
        { name: "Cabin", value: "Cabin, sans-serif" },
        { name: "PT Sans", value: "'PT Sans', sans-serif" },
        { name: "Source Sans Pro", value: "'Source Sans Pro', sans-serif" },
        { name: "Ubuntu", value: "Ubuntu, sans-serif" },
        { name: "Varela Round", value: "'Varela Round', sans-serif" },
        { name: "Josefin Sans", value: "'Josefin Sans', sans-serif" },
        { name: "Dancing Script", value: "'Dancing Script', cursive" },
        { name: "Pacifico", value: "Pacifico, cursive" },
        { name: "Caveat", value: "Caveat, cursive" },
        { name: "Lobster", value: "Lobster, cursive" },
        { name: "Abril Fatface", value: "'Abril Fatface', cursive" },
        { name: "Archivo", value: "Archivo, sans-serif" },
        { name: "Exo 2", value: "'Exo 2', sans-serif" },
        { name: "Manrope", value: "Manrope, sans-serif" },
        { name: "Mulish", value: "Mulish, sans-serif" },
        { name: "Signika", value: "Signika, sans-serif" },
    ];
    // Initialize logoWidth from funnel settings when component mounts or funnel changes
    useEffect(() => {
        setLogoWidth(settingsFunnel?.logoWidth || 20);
        setSettingsFunnel({ ...settingsFunnel, logoWidth: logoWidth });

    }, [settingsFunnel?.logoWidth]);

    if (!open) return null;

    function handleChange(e) {
        const newWidth = parseInt(e.target.value) || 20;
        setLogoWidth(newWidth);
        setSettingsFunnel({ ...settingsFunnel, logoWidth: newWidth });
    }


    function handleChangePrimaryColor(e) {
        const newColor = e.target.value;
        setSettingsFunnel({ ...settingsFunnel, primaryColor: newColor });
    }

    function handleChangeSecondaryColor(e) {
        const newColor = e.target.value;
        setSettingsFunnel({ ...settingsFunnel, secondaryColor: newColor });
    }

    function handleChangeBackgroundColor(e) {
        const newColor = e.target.value;
        setSettingsFunnel({ ...settingsFunnel, backgroundColor: newColor });
    }

    function handleChangeFont(e) {
        const newFont = e.target.value;
        setSettingsFunnel({ ...settingsFunnel, font: newFont });
    }

    function handleChangeButtonTextColor(e) {
        const newColor = e.target.value;
        setSettingsFunnel({ ...settingsFunnel, buttonTextColor: newColor });
    }

    function onCancel() {

        setSettingsFunnel({ ...currentSettings });

        //setCurrentSettings(settingsFunnel);
        onClose();
    }

    function handleChangeSpacing(e) {
        const newSpacing = parseInt(e.target.value) || 0;
        setSettingsFunnel({ ...settingsFunnel, spacing: newSpacing });
    }

    return (
<div
          className="fixed inset-0 z-50 flex justify-center items-center"
          style={{  zIndex: 10000 }}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 min-w-[450px] max-w-[95vw] w-full sm:w-[400px] relative">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl"
              onClick={onCancel}
              aria-label="Fechar"
            >
              &times;
            </button>
            <h2 className="text-lg font-bold mb-4 text-gray-800">Design do Funil</h2>
            <form 
              onSubmit={(e) => {
                e.preventDefault();
                // Ensure settings is an object, not a string
              
                
                    onSave(settingsFunnel);
                    onClose();
              }} 
              className="flex flex-col gap-4"
            >
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Largura da Logo</label>
                <input
                  type="range"
                  className="w-full"
                  value={logoWidth}
                  onChange={handleChange}
                  min="5"
                  max="200"
                />

              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Espaçamento dos Elementos</label>
                <input
                  type="range"
                  className="w-full"
                  value={settingsFunnel.spacing}
                  onChange={handleChangeSpacing}
                  min="0"
                  max="100"
                />

              </div>

              <div className="flex flex-row gap-4">
              <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: 12}}> Cor Primária</label>
                  <input
                    type="color"
                    className="w-full h-10 p-0 border-0 rounded-md"
                    value={settingsFunnel.primaryColor}
                    onChange={handleChangePrimaryColor}
                    style={{ backgroundColor: settingsFunnel.primaryColor }}
                  />
                </div>

                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: 12}}>Cor Secundária</label>
                  <input
                    type="color"
                    className="w-full h-10 p-0 border-0 rounded-md"
                    value={settingsFunnel.secondaryColor}
                    onChange={handleChangeSecondaryColor}
                    style={{ backgroundColor: settingsFunnel.secondaryColor }}
                  />
                </div>

                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: 12}}>Cor Texto Botão</label>
                  <input
                    type="color"
                    className="w-full h-10 p-0 border-0 rounded-md"
                    value={settingsFunnel.buttonTextColor}
                    onChange={handleChangeButtonTextColor}
                    style={{ backgroundColor: settingsFunnel.buttonTextColor }}
                  />
                </div>

                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: 12}}>Cor de Fundo</label>
                  <input
                    type="color"
                    className="w-full h-10 p-0 border-0 rounded-md"
                    value={settingsFunnel.backgroundColor}
                    onChange={handleChangeBackgroundColor}
                    style={{ backgroundColor: settingsFunnel.backgroundColor }}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: 12}}>Cor de Textos</label>
                  <input
                    type="color"
                    className="w-full h-10 p-0 border-0 rounded-md"
                    value={settingsFunnel.textColor || "#222222"}
                    onChange={e => setSettingsFunnel({ ...settingsFunnel, textColor: e.target.value })}
                    style={{ backgroundColor: settingsFunnel.textColor || "#222222" }}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fontes Primárias</label>
                {/*
                  Font options with live preview in the dropdown.
                  Note: For best results, ensure these fonts are loaded via Google Fonts or similar in your app.
                */}
              
                    <select
                      className="w-full border rounded px-2 py-2 mt-1"
                      value={settingsFunnel.font || "Inter, sans-serif"}
                      onChange={e => setSettingsFunnel({ ...settingsFunnel, font: e.target.value })}
                       
                    >
                      {fontOptions.map(font => (
                        <option
                          key={font.value}
                          value={font.value}
                          style={{
                            fontFamily: font.value,
                            fontSize: "1.1em",
                          }}
                        >
                          {font.name}
                        </option>
                      ))}
                    </select>
                  
                
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Fontes Secundárias</label>
                {/*
                  Font options with live preview in the dropdown.
                  Note: For best results, ensure these fonts are loaded via Google Fonts or similar in your app.
                */}
              
                    <select
                      className="w-full border rounded px-2 py-2 mt-1"
                      value={settingsFunnel.fontSecondary || "Inter, sans-serif"}
                      onChange={e => setSettingsFunnel({ ...settingsFunnel, fontSecondary: e.target.value })}
                       
                    >
                      {fontOptions.map(font => (
                        <option
                          key={font.value}
                          value={font.value}
                          style={{
                            fontFamily: font.value,
                            fontSize: "1.1em",
                          }}
                        >
                          {font.name}
                        </option>
                      ))}
                    </select>
                  
                
              </div>




              <div className="flex items-center justify-between mt-2">
              <button
                  type="button"
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition flex items-center gap-2"
                  onClick={onCancel}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition flex items-center gap-2"
                >
                  Salvar Design
                </button>
           
              </div>
            </form>
          </div>
        </div>  )
}